import { apiCall } from '../apiHelpers';

export const REPORT_REASON_OPTIONS = [
  { value: 'harassment', label: 'Harassment' },
  { value: 'hate_speech', label: 'Hate speech' },
  { value: 'spam', label: 'Spam' },
  { value: 'inappropriate_content', label: 'Inappropriate content' },
  { value: 'other', label: 'Other' },
];

export const reportContent = async ({
  userId,
  targetType,
  targetUserId,
  targetPostId,
  clubId,
  reason,
  details,
}) => {
  const params = new URLSearchParams({ userId: userId.toString() });
  return apiCall(`/v1/moderation/report?${params}`, {
    method: 'POST',
    body: JSON.stringify({
      targetType,
      targetUserId,
      targetPostId,
      clubId,
      reason,
      details,
    }),
  });
};

export const blockUser = async (userId, blockedUserId) => {
  const params = new URLSearchParams({ userId: userId.toString() });
  return apiCall(`/v1/moderation/block?${params}`, {
    method: 'POST',
    body: JSON.stringify({ blockedUserId, userId }),
  });
};

export const unblockUser = async (userId, blockedUserId) => {
  const params = new URLSearchParams({ userId: userId.toString() });
  return apiCall(`/v1/moderation/block/${encodeURIComponent(blockedUserId)}?${params}`, {
    method: 'DELETE',
  });
};

export const getBlockedUsers = async (userId) => {
  const params = new URLSearchParams({ userId: userId.toString() });
  return apiCall(`/v1/moderation/blocks?${params}`);
};
